export const PreviewTableHeader = [
    {
        Header: 'Staff ID',
        accessor: 'staff_id'
    },
    {
        Header: 'Name',
        accessor: 'staff_name'
    },
    {
        Header: 'Identification',
        accessor: 'staff_identification'
    },
    {
        Header: 'NRIC/Passport',
        accessor: 'staff_identification_number'
    },
    {
        Header: 'Resident status',
        accessor: 'resident_status'
    },
    {
        Header: 'Disability status',
        accessor: 'disability_status'
    },
    {
        Header: 'Marriage status',
        accessor: 'marriage_status'
    },
    {
        Header: 'Spouse disability status',
        accessor: 'spouse_disability_status'
    },
    {
        Header: 'Address',
        accessor: 'address'
    },
    {
        Header: 'State',
        accessor: 'state'
    },
    {
        Header: 'Country',
        accessor: 'country'
    },
    {
        Header: 'Salary category',
        accessor: 'salary_category'
    },
    {
        Header: 'Basic salary',
        accessor: 'basic_salary'
    },
    {
        Header: 'Hiring date',
        accessor: 'hiring_date'
    },
    {
        Header: 'Bank name',
        accessor: 'bank_name'
    },
    {
        Header: 'Bank acc num',
        accessor: 'bank_acc_number'
    },
    {
        Header: 'Income tax num',
        accessor: 'income_tax_number'
    },
    {
        Header: 'EIS contribution',
        accessor: 'eis_status'
    },
    {
        Header: 'EPF contribution',
        accessor: 'epf_status'
    },
    {
        Header: 'EPF acc num',
        accessor: 'epf_acc_num'
    },
    {
        Header: 'EPF category',
        accessor: 'epf_category'
    },
    {
        Header: 'EPF employee rate',
        accessor: 'epf_employee_contribution_rate'
    },
    {
        Header: 'EPF employee custom rate',
        accessor: 'epf_employee_custom_contribution_rate'
    },
    {
        Header: 'EPF employer rate',
        accessor: 'epf_employer_contribution_rate'
    },
    {
        Header: 'EPF employer custom rate',
        accessor: 'epf_employer_custom_contribution_rate'
    },
    {
        Header: 'SOCSO contribution',
        accessor: 'socso_status'
    },
    {
        Header: 'SOCSO category',
        accessor: 'socso_category'
    },
    {
        Header: 'SOCSO acc num',
        accessor: 'socso_acc_number'
    },
    {
        Header: 'Zakat contribution',
        accessor: 'zakat_status'
    },
    {
        Header: 'Zakat amount',
        accessor: 'zakat_amount'
    }
]